module.exports = __webpack_public_path__ + "static/sport/swiper-1.94c9818.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jump/swiper/swiper-1.jpg
// module id = +uCx
// module chunks = 0